import { Typography } from "@/components/common/Typography/Typography"
import { FileInfo } from "@/components/feature/KnowledgebaseFileListItem/partials"
import { type DocumentTagEntry } from "@/components/feature/KnowledgebaseFilters/DocumentTagCategoryMenu"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import type { KnowledgebaseFile } from "@/types/knowledgebase"
import { classNames } from "@/utils/classNames"

interface SelectableDocumentRowProps {
  file: KnowledgebaseFile
  tagEntries: DocumentTagEntry[]
  isLast: boolean
  showExpiryDateColumn: boolean
}

export const SelectableDocumentRow: React.FC<SelectableDocumentRowProps> = ({
  file,
  tagEntries,
  isLast,
  showExpiryDateColumn,
}) => {
  const { currentLanguage } = useTranslation()
  return (
    <div
      role="row"
      aria-label={file.fileName}
      className={classNames(
        "flex min-h-20 items-stretch",
        !isLast && "border-b border-grey3",
      )}
    >
      <div
        role="cell"
        className={classNames(
          "flex min-w-0 flex-1 items-center px-0 py-2",
          showExpiryDateColumn ? "border-r border-grey3" : "",
        )}
      >
        <FileInfo
          item={file}
          isHover={false}
          onTitleClick={() => {}}
          isTitleInteractive={false}
          showCheckbox={false}
          tagEntries={tagEntries}
          handleTag={() => {}}
          kbTaggingFlowEnabled={false}
        />
      </div>
      {showExpiryDateColumn ? (
        <div role="cell" className="flex w-32 shrink-0 items-center px-3 py-3">
          <Typography
            as="span"
            variant="textS"
            className="text-muted-foreground"
          >
            {file.expiryDate
              ? new Date(file.expiryDate).toLocaleDateString(
                  currentLanguage === "EN" ? "en" : "de",
                )
              : "—"}
          </Typography>
        </div>
      ) : null}
    </div>
  )
}
